var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmsStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1227 9.13976V12.0174C16.1227 14.5352 14.6801 15.6143 12.5163 15.6143H5.30362C3.13981 15.6143 1.69727 14.5352 1.69727 12.0174V6.98157C1.69727 4.46368 3.13981 3.38458 5.30362 3.38458H8.90997",
    stroke: "#84818A",
    strokeWidth: 1.29492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30273 7.34125L7.56031 9.13974C8.30322 9.72965 9.52217 9.72965 10.2651 9.13974",
    stroke: "#84818A",
    strokeWidth: 1.29492,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3033 2.89542L14.5053 3.30547C14.6063 3.5069 14.8587 3.69395 15.0823 3.73711L15.3564 3.78028C16.1786 3.91696 16.3734 4.52125 15.7819 5.11835L15.5295 5.37014C15.3636 5.54279 15.2698 5.87372 15.3203 6.10393L15.3564 6.255C15.58 7.24777 15.0534 7.62904 14.1879 7.11108L14.0004 7.00317C13.7768 6.87368 13.4162 6.87368 13.1926 7.00317L13.005 7.11108C12.1323 7.63624 11.6058 7.24777 11.8366 6.255L11.8726 6.10393C11.9231 5.87372 11.8294 5.54279 11.6635 5.37014L11.411 5.11835C10.8196 4.52125 11.0143 3.91696 11.8366 3.78028L12.1107 3.73711C12.327 3.70114 12.5867 3.5069 12.6877 3.30547L12.8896 2.89542C13.2791 2.11128 13.9138 2.11128 14.3033 2.89542Z",
    stroke: "#84818A",
    strokeWidth: 1.29492,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsStar);
export default __webpack_public_path__ + "static/media/sms-star.3fcbce69b9a99b91efadb7648dba2af3.svg";
export { ForwardRef as ReactComponent };